import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter, Route, Redirect } from 'react-router-dom'
import moment from 'moment'
import { GTM_ENV } from 'Config/constants'

import LetterBox from './LetterBox/LetterBox'
import AdressPage from './AdressPage/AdressPage'
import SubscriptionPage from './SubscriptionPage/SubscriptionPage'
import ContractPage from './ContractPage/ContractPage'
import InvoicesPage from './InvoicesPage/InvoicesPage'
import PaymentMeansPage from './PaymentMeansPage/PaymentMeansPage'
import FormalitesPage from './FormalitesPage/FormalitesPage'
import { isEmpty, get } from 'lodash'
import BandeauFormalites from '@components/BandeauFormalites'
import CustomerNavigation from './CustomerNavigation/CustomerNavigation'

import { openModal } from 'Actions/ui'
import { notify } from 'Actions/notifications'
import { setCurrentUser } from 'Actions/user'
import { getUser } from '../../api/user'
import initSatisMeter from 'Helpers/satis-meter'

import 'Ui/input.sass'
import { initializeLogRocket } from '../../helpers/logrocket'
import LogRocket from 'logrocket'
import CompteProPage from './CompteProPage/CompteProPage'
import ComptabilitePage from './ComptabilitePage/ComptabilitePage'
import AssurancePage from './AssurancePage/AssurancePage'
import AssistanceJuridiquePage from './AssistanceJuridiquePage/AssistanceJuridiquePage'
import SiteInternetPage from './SiteInternetPage/SiteInternetPage'
import { activateCaarlTour } from '../../actions/ui'
import { representantChangeInProgress } from '../../utils/inpi-scores-checks'

const companiesExcludedForAnnualOffer = GTM_ENV === 'staging'
  ? [16]
  : [13]

export const requiredFieldsForAMLPopup = [
  'ppe',
  'activity',
  'has_expert',
]

// Inscription domiciliation intégrée au tunnel création v2 (groupe « Votre domiciliation ») :
// `companyCreation.netheos_course_uuid` n'est posé que par ce tunnel, jamais par le tunnel
// classique — un client classique n'est donc jamais redirigé vers la création. Le dossier y reste
// tant que le contrat n'est pas signé (`ATTENTE_ARCHIVAGE` / `ARCHIVE`), y compris en vérification
// manuelle : l'écran Justificatifs affiche lui-même cet état, pas de modale bloquante
// (cf. specs/features/creation-societe-v2/parcours.md § 1).
const CREATION_DOMICILIATION_IN_PROGRESS_STATUSES = ['COMPTE_CREE', 'ATTENTE_DOCUMENTS', 'DOCUMENTS_A_VALIDER']

const isCreationDomiciliationInProgress = (user) => !!user.companyCreation?.netheos_course_uuid
  && CREATION_DOMICILIATION_IN_PROGRESS_STATUSES.includes(user.netheos_status)

const inpiCheckFailedAndNoForcedValidation = user =>
  (!user.siren_validation_at || moment(user.siren_validation_at).isBefore(moment().subtract(3, 'month')))
  && user.inpi_check_fails

class CustomerArea extends Component {
  constructor(props) {
    super(props)
    const mediaQuery = window.matchMedia('(max-width: 768px)');

    this.state = {
      isMobile: mediaQuery.matches,
    }
  }

  componentDidMount() {
    initializeLogRocket()

    const { history, location, dispatch, storeUserData } = this.props

    getUser(res => {
      console.log('getUser res --------------------------------->')
      console.log(res)

      if (isEmpty(res) || get(res, 'message') === 'Unauthorized') {
        dispatch(notify('info', 'Votre session a expiré.', 4000))
        // on garde la page demandée (lien d'un email, ex. /mon-compte/site-internet)
        // pour y revenir après connexion
        const requested = `${location?.pathname || ''}${location?.search || ''}`
        const toLogin = requested.startsWith('/mon-compte')
          ? `/login?redirect=${encodeURIComponent(requested)}`
          : '/login'
        history.push(toLogin)

        return
      }

      if (res?.email) {
        LogRocket.identify(res.email)
      }

      if (res.aml_total_points === 100 // liste noire
        || res.isBlockedForDuplicate
        || res.beneficiairesFilesSuspended
      ) {
        dispatch(
          openModal('notification', {
            message:
              'Votre compte est en cours de validation.',
            onButtonClick: () => history.push('/'),
            unclosable: true,
          }),
        )

        return
      }

      // Dossier de création non terminé, initié via l'onboarding (paiement avant création de
      // compte) ou via l'API MCP (`origin: 'mcp'`, dossier payé depuis un assistant IA) :
      // `origin` est posé une seule fois à la création (jamais à recalculer/
      // resynchroniser ensuite, contrairement aux anciens flags `has_pending_prepaid_*`). Un
      // dossier `origin: 'customer_space'` (créé depuis l'espace client) ne déclenche jamais
      // cette redirection forcée, quel que soit son état — il garde le CTA "Finaliser ma
      // formalité" de FormalitesPage.
      const { companyCreation, microCompanyCreation } = res
      if (['onboarding', 'mcp'].includes(companyCreation?.origin)
        && (!companyCreation.finalized || isCreationDomiciliationInProgress(res))) {
        history.push('/creation-entreprise/dossier')
        return
      }
      if (microCompanyCreation?.origin === 'onboarding' && !microCompanyCreation.finalized) {
        // if address not chosen yet, redirect to address selection
        if (res.contracts[0] && !res.contracts[0].address_id) {
          history.push('/creation-entreprise/adresses')
          return
        }
        history.push(`/micro/creation-entreprise-informations?company_creation_id=${microCompanyCreation.id}`)
        return
      }

      // Ancien tunnel intact : la réexpédition d'un dossier du tunnel création v2 se saisit dans
      // son questionnaire (step 18), pas sur `/inscription-prepaid/adresse`.
      if (res.has_pending_prepaid_domiciliation && !res.expedition_city
        && !companyCreation?.netheos_course_uuid) {
        history.push('/inscription-prepaid/adresse')
        return
      }

      if (!res.is_domiciliated_user) {
        storeUserData(res)
        return
      }

      initSatisMeter(res)

      if (res.account_status === 'DESABONNE' || res.account_status === 'RADIE') {
        dispatch(
          openModal('notification', {
            message:
              'Votre compte est suspendu. Si vous pensez qu’il s’agit d’une erreur, merci de contacter le service client',
            onButtonClick: () => history.push('/'),
            unclosable: true,
          }),
        )

        return
      }

      if (res.hasScreeningAlert) {
        dispatch(
          openModal('notification', {
            message:
              'Votre compte est en cours de validation, merci de vous reconnecter ultérieurement.',
            onButtonClick: () => history.push('/login'),
            unclosable: true,
          }),
        )

        return
      }

      // TODO uncomment when we finish this feature - if we finish it one day, an other similar feature has been done
      // if (res.has_other_unpaid_account) {
      //   storeUserData(res)
      //   history.push('/mon-compte/paiement')

      //   dispatch(
      //     openModal('notification', {
      //       message:
      //         'Votre compte est bloqué. Merci d’adresser un email à contact@ma-domiciliation.fr',
      //       onButtonClick: () => history.push('/'),
      //       unclosable: true,
      //     }),
      //   )

      //   return
      // }

      // Dossier `origin: 'customer_space'` avec domiciliation via le tunnel création v2 : pièces,
      // questionnaire et signature se font dans ce tunnel, pas dans l'ancien parcours ni derrière
      // la modale « en cours de validation » (un dossier `onboarding` a déjà été redirigé
      // plus haut).
      if (isCreationDomiciliationInProgress(res)) {
        storeUserData(res)
        history.push('/creation-entreprise/dossier')
        return
      }

      switch (res.netheos_status) {
        // case of successful login
        case 'ATTENTE_ARCHIVAGE':
        case 'ACCEPTE':
        case 'ARCHIVE': {
          storeUserData(res)

          this.openNeededModals(res)
          if (res.needs_caarl_tour_on_login) {
            // don't activate tour on mobile
            
            if (!this.state.isMobile) {
            // if (mediaQuery.matches) {
              dispatch(activateCaarlTour())
            }
          }

          break
        }
        case 'DOCUMENTS_A_VALIDER':
          dispatch(
            openModal('notification', {
              message:
                'Votre compte est en cours de validation. Vous recevrez un email dès que votre compte sera validé.',
              onButtonClick: () => history.push('/login'),
              unclosable: true,
            }),
          )
          break
        case 'ATTENTE_DOCUMENTS':
          storeUserData(res)
          // TODO check if this still can happen ; it shouldn't when we have complete process (maybe only if inpi bug, but in this case we'll have no inpi data so no bad score here) of auto fill depending on siren (right now it's not yet done on first steps for juridic form and denomination)
          if (inpiCheckFailedAndNoForcedValidation(res)) {
            history.push('/inscription/validation?validation=siren')
            return
          }

          history.push('/inscription/signature')
          dispatch(notify('info', 'Il reste quelques étapes pour finaliser votre dossier.', 5000))
          break
        case 'COMPTE_CREE':
          storeUserData(res)
          history.push('/inscription/contrat')
          dispatch(notify('info', 'Il reste quelques étapes pour finaliser votre dossier.', 5000))
          break
        default:
          storeUserData(res)
          dispatch(
            notify(
              'info',
              'Une erreur est survenue, merci de contacter le service client si cela persiste.',
              5000,
            ),
          )
          history.push('/login')
      }
    })
  }

  // depending on missing documents/bad inpi score/unpaid invoices, etc, open modal or redirect to specific page
  openNeededModals(user) {
    const { dispatch, history } = this.props

    // this discount modal is desactivated for now
    // if (moment().isAfter(moment('04/12/2023 12:00', 'DD/MM/YYYY HH:mm'))
    //   && user.payment_interval === 'mensuel'
    //   && !companiesExcludedForAnnualOffer.includes(user.company.id)

    if (user.unpaidInvoices.length) {
      history.push('/mon-compte/paiement')

      dispatch(
        openModal('notification', {
          message:
            'Compte bloqué. Une facture est en attente de paiement. Merci de modifier votre moyen de paiement ou d’approvisionner votre compte en banque, afin que le paiement de votre abonnement puisse être effectué.',
          buttonText: 'Ok',
        }),
      )

      return
    }

    if (user.payment_interval === 'mensuel') {
      dispatch(openModal('blackFridayAnnualOffer'))
    }

    if (user.pendingStripeInvoices.length) {
      dispatch(
        openModal('pendingInvoicesPaymentModal', {
          pendingStripeInvoices: user.pendingStripeInvoices,
          unclosable: true,
        }),
      )

      return
    }

    // TODO rm modal
    // if (!user.attestation_comptable_signed) {
    //   dispatch(
    //     openModal('attestation', {
    //       unclosable: !!user.siren,
    //     }),
    //   )
    // }

    // must stay before redirect on representantNeedingJustif, because when change is in progress it will also be considered as needing justif
    // also must stay before missing_netheos_documents check because when changing representant we have missing contract until new one is signed
    if (representantChangeInProgress(user)) {
      history.push('/changement-de-representant')
      return
    }

    if (inpiCheckFailedAndNoForcedValidation(user)) {
      dispatch(openModal('wrongSirenScore', { unclosable: true }))
      return
    }

    if (user.representantNeedingJustif) {
      history.push('/justificatif-representant')
      return
    }

    if (user.needsActualisation) {
      history.push('/actualisation')
      return
    }

    if (user.missing_netheos_documents) {
      dispatch(
        openModal('notification', {
          message:
            'Documents manquants - Compte bloqué temporairement. Afin de débloquer le compte, merci de contacter notre support par email : contact@ma-domiciliation.fr',
          onButtonClick: () => history.push('/login'),
          unclosable: true,
        }),
      )
      return
    }

    const isUnder3months = moment(user.created_at).isAfter(moment().subtract(3, 'month'))

    if (
      (requiredFieldsForAMLPopup.some(field => user[field] === null || user[field] === '')
      || (!user.siren && !user.rna))
    ) {
      dispatch(
        openModal('aml', {
          unclosable: !isUnder3months && !user.no_siren_access,
        }),
      )
    }

    const needsBeJustif = !user.beneficiairesFilesSuspended
      && user.beneficiairesNeedingJustif.length
      && user.juridic_form !== 'EI'
      && user.juridic_form !== 'Micro-entreprise'

    if (needsBeJustif) {
      dispatch(
        openModal('beneficiaires', {
          unclosable: true,
        }),
      )
    }

    if (!(user.ppeOrigin || user.ppeOriginOther)
      && (user.aml_score === 4 || user.ppe)
    ) {
      dispatch(
        openModal('ppeOrigin', {
          unclosable: true,
        }),
      )
    }

    if (!user.choix_domiciliation
      && user.aml_score > 2) {
      dispatch(
        openModal('choixDomiciliation', {
          unclosable: true,
        }),
      )
    }

    if ((user.siren || user.rna)
      && !user.has_kbis
      && !user.has_extrait_inpi
      && !user.has_extrait_insee
      && !user.has_extrait_pappers
    ) {
      dispatch(
        openModal('kbis', {
          unclosable: !isUnder3months,
        }),
      )
    }

    if ((user.siren || user.rna)
      && !user.has_statuts
      && user.juridic_form !== 'EI'
      && user.juridic_form !== 'Micro-entreprise'
    ) {
      dispatch(
        openModal('statuts', {
          unclosable: !isUnder3months,
        }),
      )
    }
  }

  render() {
    const { match, currentUser, location } = this.props
    const currentPage = location.pathname.replace(`${match.url}/`, '')

    const matchUrl = match.url.endsWith('/') ? match.url.slice(0, -1) : match.url

    return (
      <div className="CustomerArea">
        {currentUser.is_domiciliated_user && <BandeauFormalites currentUser={currentUser} />}
        <CustomerNavigation currentPage={currentPage}>
          {currentUser.is_domiciliated_user &&
            <>
              <Route path={`${matchUrl}/lettres`} component={LetterBox} />
              <Route path={`${matchUrl}/adresse`} component={AdressPage} />
              <Route path={`${matchUrl}/abonnement`} component={SubscriptionPage} />
              <Route path={`${matchUrl}/contrat`} component={ContractPage} />
              <Route path={`${matchUrl}/paiement`} component={PaymentMeansPage} />
            </>
          }
          <Route path={`${matchUrl}/factures`} component={InvoicesPage} />
          <Route path={`${matchUrl}/formalites`} component={FormalitesPage} />
          {currentUser.is_domiciliated_user &&
            <>
              <Route path={`${matchUrl}/compte-pro`} component={CompteProPage} />
              <Route path={`${matchUrl}/comptabilite`} component={ComptabilitePage} />
              <Route path={`${matchUrl}/assurance`} component={AssurancePage} />
              <Route path={`${matchUrl}/assistance-juridique`} component={AssistanceJuridiquePage} />
              <Route path={`${matchUrl}/site-internet`} component={SiteInternetPage} />
            </>
          }
          <Route exact path={`${matchUrl}/`}>
            {currentUser.is_domiciliated_user ? 
              <Redirect to={`${matchUrl}/lettres`} />
              : <Redirect to={`${matchUrl}/formalites`} />
            }
          </Route>
        </CustomerNavigation>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

const mapDispatchToProps = dispatch => ({
  storeUserData: res => dispatch(setCurrentUser(res)),
  dispatch,
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerArea))
